import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";
import { http } from "../../lib/api";
import { can } from "../../lib/auth";
import { visibleGroups, visibleTabs } from "../../lib/nav";
import { preguntarCopiloto } from "../../lib/copiloto";

const limpio = (t) => String(t ?? "").replace(/["\\\n\r]/g, " ").slice(0, 200);

export const CommandPalette = ({ open, setOpen, user, actions }) => {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  useEffect(() => {
    const h = (e) => { if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen((o) => !o); } };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [setOpen]);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return undefined; }
    const t = setTimeout(() => http.get("/buscar", { params: { q } }).then((r) => setRes(Array.isArray(r.data) ? r.data.filter((x) => x && x.url) : [])).catch(() => setRes([])), 220);
    return () => clearTimeout(t);
  }, [q]);
  const pages = useMemo(() => visibleGroups(user).flatMap((g) => (g.tabs ? visibleTabs(g, user).map((t) => ({ l: `${g.l} › ${t.l}`, to: `/${g.key}/${t.k}` })) : [{ l: g.l, to: g.to }]))
    .concat([{ l: "Manual", to: "/manual" }, { l: "Trafalgar AI", to: "/asistente" }]), [user]);
  const acts = [can(user, "deals.crear") && { l: "Nuevo deal", f: actions.nuevoDeal }, { l: "Cotizar", f: actions.cotizar },
    can(user, "equipo.invitar") && { l: "Invitar usuario", f: () => nav("/admin/equipo?invitar=1") }].filter(Boolean);
  const go = (fn) => { setOpen(false); setQ(""); fn(); };
  const grupos = res.reduce((a, r) => ({ ...a, [r.tipo]: [...(a[r.tipo] || []), r] }), {});
  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Buscar… o pregúntale al copiloto" value={q} onValueChange={setQ} data-testid="cmdk-input" />
      <CommandList data-testid="cmdk-list">
        <CommandEmpty>Sin resultados.</CommandEmpty>
        <CommandGroup heading="Copiloto"><CommandItem value={`copiloto ${q}`} onSelect={() => { const t = q.trim(); go(() => preguntarCopiloto(t || "¿Qué puedo hacer en esta pantalla?")); }} data-testid="cmdk-copiloto">
          <span className="font-semibold text-[#E8643C]">Pregúntale al copiloto…</span>{q.trim() && <span className="ml-2 truncate text-xs text-[#5C5850]">«{q.trim()}»</span>}</CommandItem></CommandGroup>
        {Object.entries(grupos).map(([tipo, rs]) => (
          <CommandGroup key={tipo} heading={tipo}>{rs.map((r, i) => (
            <CommandItem key={`${tipo}-${i}-${r.url}`} value={limpio(`${tipo} ${i} ${r.titulo} ${r.sub}`)} onSelect={() => go(() => nav(r.url))} data-testid="cmdk-result">
              <span className="font-medium">{r.titulo}</span><span className="ml-2 text-xs text-[#8C867A]">{r.sub}</span></CommandItem>))}</CommandGroup>))}
        <CommandGroup heading="Acciones rápidas">{acts.map((a) => <CommandItem key={a.l} value={`accion ${a.l}`} onSelect={() => go(a.f)} data-testid={`cmdk-action-${a.l.toLowerCase().replace(/ /g, "-")}`}>{a.l}</CommandItem>)}</CommandGroup>
        <CommandGroup heading="Páginas">{pages.map((p) => <CommandItem key={p.to} value={`pagina ${p.l}`} onSelect={() => go(() => nav(p.to))} data-testid="cmdk-page">{p.l}</CommandItem>)}</CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};
